export const glossaire_date_format = {
  'jj/mm/aaaa hh:mm:ss': 1,
  'jj/mm/aaaa': 2,
};
